export const DEFAULT_REDIRECT_DELAY = 3000;
export const MIN_REDIRECT_DELAY = 0;
// setTimeout treats bigger delays as 0, so cap the value on the timer limit
export const MAX_TIMEOUT_DELAY = 2147483647;

/**
 * Delay (in ms) before redirecting to the merchant return url on the status page.
 * Comes from the commerce account checkout options, falls back to the default one.
 */
function getRedirectDelay(checkoutOptions) {
  const value = checkoutOptions?.redirect_delay;

  if (value === null || value === undefined || value === '') {
    return DEFAULT_REDIRECT_DELAY;
  }

  const delay = Number(value);

  if (!Number.isFinite(delay) || delay < MIN_REDIRECT_DELAY) {
    return DEFAULT_REDIRECT_DELAY;
  }

  return Math.min(delay, MAX_TIMEOUT_DELAY);
}

export default getRedirectDelay;
